/**
 * Collection page filters: sync sort dropdown, AJAX filter form, clear/remove facets, load more, price slider re-init.
 * Matches previous theme (elixir) behavior for #CollectionFiltersForm, .flForm .custCheck, .prRange, #SortBy, .actFilter.
 */
(function() {
  'use strict';

  function initCollectionFilters() {
    var $form = document.getElementById('CollectionFiltersForm');
    if (!$form || typeof window.$ === 'undefined') return;

    var $ = window.$;

    // Toolbar sort (#SortBySt) -> sync to sidebar hidden sort (#SortBy) and trigger filter
    $(document).on('change', '#SortBySt', function() {
      var value = $(this).val();
      var $sortBy = $('#SortBy');
      if ($sortBy.length) {
        $sortBy.val(value).trigger('change');
      }
    });

    // Filter form: checkbox, price inputs, or sidebar sort change -> build URL and fetch
    $(document).on('change', '.flForm .custCheck, .flForm .prRange, #SortBy', function() {
      var form = document.getElementById('CollectionFiltersForm');
      if (!form) return;
      var base = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
      var query = $(form).serialize();
      var url = query ? base + '?' + query : base;
      ajaxFilter(url);
    });

    // Clear all / remove single facet -> navigate to link href via AJAX
    $(document).on('click', '.actFilter', function(e) {
      var href = $(this).attr('href');
      if (!href || href === '#') return;
      e.preventDefault();
      var url = href.indexOf('//') === 0 ? window.location.protocol + href : (href.indexOf('/') === 0 ? window.location.protocol + '//' + window.location.hostname + href : href);
      ajaxFilter(url);
    });

    function ajaxFilter(url) {
      $.ajax({
        type: 'GET',
        url: url,
        data: {},
        beforeSend: function() {
          $('body').addClass('loading hideOverly');
        },
        complete: function(xhr) {
          var responseText = xhr.responseText || '';
          var $doc = $(responseText);

          if ($('.productList .grid-products', $doc).length) {
            $('.productList .grid-products').html($('.productList .grid-products', $doc).html());
          }
          if ($('.filters-toolbar__product-count-and-title', $doc).length) {
            $('.filters-toolbar__product-count-and-title').html($('.filters-toolbar__product-count-and-title', $doc).html());
          }
          if ($('#CollectionFiltersForm', $doc).length) {
            $('#CollectionFiltersForm').html($('#CollectionFiltersForm', $doc).html());
          }
          if ($('.active-facets', $doc).length) {
            $('.active-facets').html($('.active-facets', $doc).html());
          }
          if ($('.pagination', $doc).length) {
            $('.pagination').html($('.pagination', $doc).html());
            $('.pagination').show();
          } else {
            $('.pagination').hide();
          }
          if ($('.infinitpaginOuter', $doc).length && $('.infinitpaginOuter', $doc).html()) {
            $('.infinitpaginOuter').html($('.infinitpaginOuter', $doc).html());
            $('.infinitpaginOuter').show();
          } else {
            $('.infinitpaginOuter').empty().hide();
          }

          $('body').removeClass('loading hideOverly');
          loadMoreBtn();
          reinitPriceSlider();
          if (typeof history !== 'undefined' && history.pushState) {
            history.pushState({ page: url }, '', url);
          }
        }
      });
    }

    function loadMoreBtn() {
      $(document).off('click.collectionFiltersLoadMore', '.infinitpagin a.loadMore');
      $(document).on('click.collectionFiltersLoadMore', '.infinitpagin a.loadMore', function(e) {
        e.preventDefault();
        var moreURL = $(this).attr('href');
        if (moreURL) loadMore(moreURL);
      });
    }

    function loadMore(moreURL) {
      if (!moreURL) return;
      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: moreURL,
        beforeSend: function() {
          var outer = document.querySelector('.infinitpaginOuter');
          if (outer && outer.getAttribute('data-type') === 'button') {
            $('body').addClass('loading hideOverly');
          }
        },
        complete: function(xhr) {
          var responseText = xhr.responseText || '';
          var $doc = $(responseText);
          if ($('.productList .grid-products').length && $('.productList .grid-products', $doc).length) {
            $('.productList .grid-products').append($('.productList .grid-products', $doc).html());
          } else if ($('.productList .list-view-items').length && $('.productList .list-view-items', $doc).length) {
            $('.productList .list-view-items').append($('.productList .list-view-items', $doc).html());
          }
          if ($('.infinitpagin', $doc).html()) {
            $('.infinitpagin').html($('.infinitpagin', $doc).html());
          } else {
            $('.infinitpagin').parent().remove();
          }
          $('body').removeClass('loading hideOverly');
        }
      });
    }

    function reinitPriceSlider() {
      var $slider = $('.range-slider');
      if (!$slider.length || typeof $.fn.jRange !== 'function') return;
      var $priceBox = $slider.closest('.flPrice');
      var rangeMax = $priceBox.length && $priceBox.attr('data-range-max') ? parseInt($priceBox.attr('data-range-max'), 10) : 1000;
      var format = ($priceBox.length && $priceBox.attr('data-currency-format')) ? $priceBox.attr('data-currency-format') : '$%s';
      var minInput = $('input[name="filter.v.price.gte"]').first();
      var maxInput = $('input[name="filter.v.price.lte"]').first();
      var minVal = minInput.length ? (minInput.val() || 0) : 0;
      var maxVal = maxInput.length ? (maxInput.val() || rangeMax) : rangeMax;
      $slider.val(minVal + ',' + maxVal);
      $slider.jRange({
        from: 0,
        to: rangeMax,
        step: 1,
        format: format,
        width: 250,
        showLabels: true,
        isRange: true,
        ondragend: function(value) {
          var parts = value.split(',');
          if (minInput.length) minInput.val(parts[0]).trigger('change');
          if (maxInput.length) maxInput.val(parts[1]).trigger('change');
        }
      });
    }

    loadMoreBtn();

    // Browser back/forward: reload collection for current URL
    $(window).on('popstate.collectionFilters', function() {
      if (document.getElementById('CollectionFiltersForm')) {
        ajaxFilter(window.location.href);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilters);
  } else {
    initCollectionFilters();
  }
})();
